module.exports = __webpack_public_path__ + "img/default.1641520899224.png";